import Button from 'components/StyledButton/StyledButton';
import styled from 'styled-components';

const GreenButton = styled(Button)`
    background-color: #28a745;
    border-color: #1e7e34;
    color: #ffffff;
    height: fit-content;
    margin: auto;
    &:hover {
        background-color: #218838;
    }
`;

export default GreenButton;
